import { createSlice } from "@reduxjs/toolkit";
import {
  checkAlpineiqConnection,
  getAlpineiqDiscounts,
  getAlpineiqOverview,
} from "./alpineiqActions";

const initialState = {
  checking: false,
  // {ok, detail} of the last connection check; null until one runs.
  checkResult: null,
  overview: null,
  loadingOverview: false,
  // Rewards catalog from AIQ; null = not loaded, [] = loaded and empty.
  discounts: null,
  loadingDiscounts: false,
};

const alpineiqSlice = createSlice({
  name: "alpineiq",
  initialState,
  reducers: {
    resetAlpineiqCheck: (state) => {
      state.checking = false;
      state.checkResult = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkAlpineiqConnection.pending, (state) => {
        state.checking = true;
        state.checkResult = null;
      })
      .addCase(checkAlpineiqConnection.fulfilled, (state, { payload }) => {
        state.checking = false;
        state.checkResult = payload;
      })
      .addCase(checkAlpineiqConnection.rejected, (state, { payload }) => {
        state.checking = false;
        state.checkResult = {
          ok: false,
          detail: payload?.detail || "Connection check failed",
        };
      })
      .addCase(getAlpineiqOverview.pending, (state) => {
        state.loadingOverview = true;
      })
      .addCase(getAlpineiqOverview.fulfilled, (state, { payload }) => {
        state.loadingOverview = false;
        state.overview = payload;
      })
      .addCase(getAlpineiqOverview.rejected, (state) => {
        state.loadingOverview = false;
        state.overview = null;
      })
      .addCase(getAlpineiqDiscounts.pending, (state) => {
        state.loadingDiscounts = true;
      })
      .addCase(getAlpineiqDiscounts.fulfilled, (state, { payload }) => {
        state.loadingDiscounts = false;
        state.discounts = payload?.discounts || [];
      })
      .addCase(getAlpineiqDiscounts.rejected, (state) => {
        // 400 = integration off, 502 = AIQ down — the card shows its own
        // empty state either way.
        state.loadingDiscounts = false;
        state.discounts = null;
      });
  },
});

export const { resetAlpineiqCheck } = alpineiqSlice.actions;
export default alpineiqSlice.reducer;
